<template>
  <div class="grade-item" v-if="grade && createdState">
    <div class="grade-topbar">
      <div class="grade-info" :class="createdState">
        <div class="grade-name">
          <div class="grade-name-label">年级:</div>
          <!-- 列表状态下 -->
          <div class="grade-name-value" v-if="!grade.isEdit">
            {{ grade.gradeName }}
          </div>
          <!-- 编辑状态下 -->
          <input
            type="text"
            class="grade-name-edit"
            v-else
            :value="grade.gradeName"
            @input="gradeNameInput($event)"
          />
        </div>
        <div class="grade-number">
          <div class="grade-number-label">编号:</div>
          <!-- 列表状态下 -->
          <div class="grade-number-value" v-if="!grade.isEdit">
            {{ grade.gradeCode }}
          </div>
          <!-- 编辑状态下 -->
          <input
            type="text"
            class="grade-number-edit"
            v-else
            :value="grade.gradeCode"
            @input="gradeCodeInput($event)"
          />
        </div>
      </div>
      <div class="grade-topbar-right-contaniner">
        <!-- 已创建 -->
        <div class="state-created" v-if="createdState == 'created'">
          <div class="state-light" />
          已创建
        </div>
        <!-- 未创建 -->
        <div class="state-not-created" v-if="createdState == 'notCreated'">
          <div class="state-light" />
          未确认创建
        </div>
        <div class="operation-container">
          <button
            class="operation-button edit-button"
            @click="gradeEdit"
            v-if="!grade.isEdit"
            v-hasPermi="'sc:grade:edit'"
          >
            <i class="iconfont icon-edit" />编辑年级
          </button>
          <button
            class="operation-button complete-button"
            @click="gradeConfirmEdit"
            v-else
          >
            <i class="iconfont icon-complete" />确认修改
          </button>
          <button
            class="operation-button delete-button"
            @click="gradeDelete"
            v-hasPermi="'sc:grade:delete'"
          >
            <i class="iconfont icon-cancel" />删除
          </button>
        </div>
      </div>
    </div>
    <div class="classlist-container" v-loading="classEditLoading">
      <!-- 未创建 -->
      <div class="not-created-container" v-if="createdState == 'notCreated'">
        当前未确认创建年级，在确认创建完毕后即可添加班级。
      </div>
      <!-- 已创建 -->
      <div class="confirm-created-container" v-if="createdState == 'created'">
        <!-- 班级列表为空时且不在编辑状态下显示提示语 -->
        <div
          class="notclass-tips-container"
          v-if="
            grade.schoolClassList.length == 0 &&
            addClassList.length == 0 &&
            !isChooseCreatedClassNumModuleShow
          "
        >
          <button
            class="add-class-button"
            @click="isChooseCreatedClassNumModuleShow = true"
            v-hasPermi="'sc:class:add'"
          >
            添加班级
          </button>
          <div class="notclass-tips-text">当前年级无绑定班级，点击按钮添加班级。</div>
        </div>
        <!-- 班级列表为空时且在编辑状态下显示选择增加班级数量 -->
        <div
          class="choose-classnumber-container"
          v-if="isChooseCreatedClassNumModuleShow"
        >
          <div class="choose-input-box">
            <el-input-number
              v-model="classNum"
              size="mini"
              controls-position="right"
              :min="1"
              :max="30"
            />
            <button class="created-class-button" @click="fastCreatedClass">生成</button>
          </div>
          <div class="choose-classnum-tips-text">请选择班级数量快速生成班级。</div>
        </div>
        <!-- 班级列表 -->
        <div
          class="class-list-container"
          v-else-if="grade.schoolClassList.length != 0 || addClassList.length != 0"
        >
          <!-- 已创建的班级 -->
          <div
            class="class-item-container created-class"
            v-for="(item, index) in grade.schoolClassList"
            :key="item.classId"
            :class="colorList[index > 9 ? index % 10 : index]"
          >
            <div class="class-item-inner-box">
              <div class="inner-box-classInfo">
                <!-- 班级名 -->
                <div class="classInfo-className">
                  <span class="classInfo-label">班级:</span>
                  <div class="classInfo-text" v-show="!item.classIsEdit">
                    {{ item.className }}
                  </div>
                  <div class="classInfo-input-box" v-show="item.classIsEdit">
                    <input
                      type="text"
                      class="classInfo-input"
                      v-model="item.className"
                      maxlength="10"
                      :style="{ width: inputWid(item.className) }"
                    />
                  </div>
                </div>
                <!-- 班级编号 -->
                <div class="classInfo-classCode">
                  <span class="classInfo-label">编号:</span>
                  <div class="classInfo-text" v-show="!item.classIsEdit">
                    {{ item.classCode }}
                  </div>
                  <div class="classInfo-input-box" v-show="item.classIsEdit">
                    <input
                      type="text"
                      class="classInfo-input"
                      v-model="item.classCode"
                      maxlength="30"
                      :style="{ width: inputWid(item.classCode) }"
                    />
                  </div>
                </div>
                <!-- 确认修改按钮 -->
                <div class="inner-box-operation" v-if="item.classIsEdit">
                  <button
                    class="operation-button edit-confirm-button"
                    @click="existsClassItemConfirmEdit(item)"
                  >
                    <i class="iconfont icon-complete" />
                  </button>
                </div>
              </div>
              <!-- 操作模块-->
              <div
                class="classInfo-edit-module"
                v-if="!item.classIsEdit"
                @click="showEditClassDialog(item)"
              >
                <i class="iconfont icon-set">班级设置</i>
              </div>
            </div>
            <!-- 删除模块 -->
            <div
              class="delete-class-button"
              v-if="item.classIsEdit"
              @click="existsClassItemDelete(item, index)"
              v-hasPermi="'sc:class:delete'"
            >
              <i class="iconfont icon-cancel" />
            </div>
          </div>

          <!-- 新添加的班级 -->
          <div
            class="class-item-container add-class"
            v-for="(item, index) in addClassList"
            :key="index"
            :class="colorList[index > 9 ? index % 10 : index]"
          >
            <div class="class-item-inner-box">
              <div class="inner-box-classInfo">
                <!-- 班级名 -->
                <div class="classInfo-className">
                  <span class="classInfo-label">班级:</span>
                  <div class="classInfo-text" v-show="!item.classIsEdit">
                    {{ item.className }}
                  </div>
                  <div class="classInfo-input-box" v-show="item.classIsEdit">
                    <input
                      type="text"
                      class="classInfo-input"
                      v-model="item.className"
                      maxlength="10"
                      :style="{ width: inputWid(item.className) }"
                    />
                  </div>
                </div>
                <!-- 班级编号 -->
                <div class="classInfo-classCode">
                  <span class="classInfo-label">编号:</span>
                  <div class="classInfo-text" v-show="!item.classIsEdit">
                    {{ item.classCode }}
                  </div>
                  <div class="classInfo-input-box" v-show="item.classIsEdit">
                    <input
                      type="text"
                      class="classInfo-input"
                      v-model="item.classCode"
                      maxlength="30"
                      :style="{ width: inputWid(item.classCode) }"
                    />
                  </div>
                </div>
                <!-- 确认修改按钮 -->
                <div class="inner-box-operation" v-if="item.classIsEdit">
                  <button
                    class="operation-button edit-confirm-button"
                    @click="notCreatedClassItemEdit(item)"
                  >
                    <i class="iconfont icon-complete" />
                  </button>
                </div>
              </div>
              <!-- 操作模块-->
              <div
                class="classInfo-edit-module"
                v-if="!item.classIsEdit"
                @click="showEditStateClassItem(item)"
              >
                <i class="iconfont icon-set">编辑班级</i>
              </div>
            </div>
            <!-- 删除模块 -->
            <div
              class="delete-class-button"
              v-if="item.classIsEdit"
              @click="notCreatedClassItemDelete(index)"
            >
              <i class="iconfont icon-cancel" />
            </div>
          </div>

          <div
            class="add-class-item"
            @click="addSingleClass"
            v-if="grade.schoolClassList.length + addClassList.length < 30"
            v-hasPermi="'sc:class:add'"
          >
            <i class="iconfont icon-add" />添加班级
          </div>
        </div>

        <!-- 确认创建班级 -->
        <div class="confirm-created-class-container" v-if="addClassList.length != 0">
          <button class="confirm-created-class-button" @click="confirmCreatedClass">
            <i class="iconfont icon-confirm-created">确认创建班级</i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //新添加还未确认创建的班级列表
      addClassList: [],
      //是否显示按数量生成班级模块
      isChooseCreatedClassNumModuleShow: false,
      //修改班级loading动画
      classEditLoading: false,
      //classItem的boder颜色和背景颜色列表
      colorList: [
        "ocean",
        "success",
        "warning",
        "danger",
        "info",
        "ocean",
        "success",
        "warning",
        "danger",
        "info",
      ],
      //生成班级的班级数量
      classNum: 1,
      selectSetItemDialogTitle: "班级设置",
    };
  },
  props: {
    grade: {
      type: Object,
      require: true,
    },
    createdState: {
      type: String,
      require: true,
    },
  },
  methods: {
    gradeNameInput(e) {
      this.$emit("gradeNameInput", e.target.value);
    },
    gradeCodeInput(e) {
      this.$emit("gradeCodeInput", e.target.value);
    },
    gradeEdit() {
      this.$emit("gradeEdit");
    },
    gradeConfirmEdit() {
      if (this.grade.gradeName.length == 0 || this.grade.gradeCode.length == 0) {
        return this.$message.warning("年级名字和年级编号不能为空！");
      } else {
        this.$emit("gradeConfirmEdit", {
          createdState: this.createdState,
          gradeId: this.grade.gradeId,
        });
      }
    },
    gradeDelete() {
      this.$emit("gradeDelete", {
        createdState: this.createdState,
        gradeId: this.grade.gradeId,
        gradeName: this.grade.gradeName,
      });
    },
    fastCreatedClass() {
      this.addClassList = [];
      for (let i = 1; i <= this.classNum; i++) {
        let classInfo = {
          className: `${this.$utils.numberToChinese(i)}班`,
          classCode: `class${i}`,
          classIsEdit: false,
        };
        this.addClassList.push(classInfo);
        this.isChooseCreatedClassNumModuleShow = false;
      }
    },
    filterRepeatClass(classItem) {
      let classList = [];
      let repeatClass = [];
      classList = [...this.grade.schoolClassList, ...this.addClassList];
      for (let item of classList) {
        if (
          classItem.className == item.className ||
          classItem.classCode == item.classCode
        ) {
          repeatClass.push(item);
        }
      }
      if (repeatClass.length > 1) {
        return false;
      } else {
        return true;
      }
    },
    confirmCreatedClass() {
      const addClassList = [];
      for (let item of this.addClassList) {
        if (item.classIsEdit) {
          return this.$message.warning("请先确认修改班级信息！");
        } else if (!this.filterRepeatClass(item)) {
          Vue.set(item, "classIsEdit", true);
          return this.$message.warning("存在重复的班级名称与编号，请先将其修改");
        } else {
          let classTemplate = {
            createBy: this.user.id,
            schoolId: this.school.id,
            schoolName: this.school.schoolName,
            gradeId: this.grade.gradeId,
            gradeName: this.grade.gradeName,
            className: item.className,
            classCode: item.classCode,
          };
          addClassList.push(classTemplate);
        }
      }
      this.classEditLoading = true;
      this.post(this.$url.addClass, addClassList)
        .then((res) => {
          this.classEditLoading = false;
          if (res.code != 200) {
            return this.$message.error("创建失败");
          }
          this.$message.success("创建成功");
          this.addClassList = [];
          let classList = res.data;
          classList = classList.map((classItem) => {
            let { id, className, classCode } = classItem;
            return {
              className,
              classCode,
              classId: id,
              classIsEdit: false,
            };
          });
          this.$emit("createdClassSuccessCallBack", classList);
        })
        .catch((err) => {
          this.classEditLoading = false;
          // console.log(err);
          return this.$message.error("创建失败");
        });
    },
    showEditClassDialog(classItem) {
      // console.log(classItem)
      this.$emit("showEditClassDialog", classItem);
    },
    editClassInfo() {
      this.isSelectSetItemDialogShow = false;
      Vue.set(this.currentClassItem, "classIsEdit", true);
    },
    showEditStateClassItem(classItem) {
      Vue.set(classItem, "classIsEdit", true);
    },

    notCreatedClassItemEdit(classItem) {
      if (classItem.className.length == 0 || classItem.classCode.length == 0) {
        return this.$message.warning("班级名称与班级编号不能为空");
      } else if (!this.filterRepeatClass(classItem)) {
        return this.$message.warning("班级名称与班级编号不能重复");
      }
      Vue.set(classItem, "classIsEdit", false);
    },
    existsClassItemConfirmEdit(classItem) {
      if (classItem.className.length == 0 || classItem.classCode.length == 0) {
        return this.$message.warning("班级名称与班级编号不能为空");
      } else if (!this.filterRepeatClass(classItem)) {
        return this.$message.warning("班级名称与班级编号不能重复");
      }
      let { className, classCode, classId } = classItem;
      this.classEditLoading = true;
      this.put(this.$url.editClassInfo, {
        id: classId,
        schoolId: this.school.id,
        gradeId: this.grade.gradeId,
        classCode,
        className,
        updateBy: this.user.id,
      })
        .then((res) => {
          this.classEditLoading = false;
          if (res.code != 200) {
            return this.$message.error("修改班级信息失败");
          }
          this.$message.success("修改班级信息成功");
          Vue.set(classItem, "classIsEdit", false);
        })
        .catch((err) => {
          this.classEditLoading = false;
          this.$message.error("修改班级信息失败");
        });
    },
    notCreatedClassItemDelete(classIndex) {
      this.addClassList.splice(classIndex, 1);
    },
    existsClassItemDelete(classItem, classIndex) {
      this.$confirm(
        `是否删除${this.grade.gradeName}${classItem.className}?`,
        "删除班级确认",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.classEditLoading = true;
          this.delete(`${this.$url.deleteClass}/${classItem.classId}`)
            .then((res) => {
              console.log(res);
              this.classEditLoading = false;
              if (res.code == 500) {
                return this.$message.error(res.msg);
              } else if (res.code != 200) {
                return this.$message.error("删除失败!");
              }
              this.$message.success("删除成功");
              this.$emit("deleteClassCallBack", classIndex);
            })
            .catch((err) => {
              this.classEditLoading = false;
              this.$message.error("删除失败!");
            });
        })
        .catch(() => {
          // Vue.set(classItem, "classIsEdit", false);
        });
    },
    addSingleClass() {
      let classInfo = {
        className: "",
        classCode: "",
        classIsEdit: true,
      };
      this.addClassList.push(classInfo);
    },
    // 输入框长度
    inputWid(value) {
      if (!value || value.length <= 4) {
        return "5em";
      } else {
        return String(value).length + 1 + "em";
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "./gradeManagement-gradeItem.scss";
</style>
